import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { savePostLoginRedirect } from '../auth/redirect';

export const ProtectedRoute: React.FC = () => {
  const { initialized, authenticated, login } = useAuth();
  const location = useLocation();
  // Do not auto-trigger login here; just redirect to /login and let the user initiate.

  if (!initialized) {
    return <div />; // keep blank to avoid layout shift
  }

  if (!authenticated) {
    // As a fallback if login did not trigger (e.g. popup blocked), go to /login
    const target = location.pathname + location.search + location.hash;
    savePostLoginRedirect(target);
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};


